import * as React from "react";
import { useState } from "react";
import toast from "react-hot-toast";
import { useMediaQuery, useTheme } from "@mui/material";

import Form from "../../../../attachments/Form";
import { useResponsive } from "../../../../../../../hooks/useResponsive";
import './AttachFile.scss';
import FormDialog from "../../../../../../../components/Dialog/FormDialog";

export default function AttachFileDialog({
  open,
  close,
  cardId,
  createCardAttachmentMutate,
  loading,
  setLoading,
}) {
  const [name, setName] = useState([{ name: "" }]);
  const [file, setFile] = useState([{ file: null }]);
  const isMobile = useResponsive("down", "md");
   const theme = useTheme();
   const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
    
  const handleNameChange = (e, index) => {
    const newName = [...name];
    newName[index] = { name: e.target.value };
    setName(newName);
  };
  const handleFileChange = (e, index) => {
    if (e.target.files.length > 0) {
      setFile([...e.target.files]);
    } else {
      setFile([{ file: null }]);
    }
  };

  const resetState = () => {
    setName([{ name: "" }]);
    setFile([{ file: null }]);
  };

  const handleSubmit = () => {
    const formData = file.map((item, index) => ({
      name: name[index]?.name ?? item.name,
      file: file[index],
    }));

    const fileData = new FormData();
    fileData.append("card_id", cardId);

    const namesArray = formData.map((item) => item.name);
    const filesArray = formData.map((item) => item.file);

    fileData.append("names", namesArray.join(", "));
    filesArray.forEach((file) => {
      fileData.append("files", file);
    });
    if (formData[0].file.name) {
      setLoading(true);
      createCardAttachmentMutate(fileData);
    } else {
      toast.error("Please upload file");
    }
  };
  return (
    <React.Fragment>
      <FormDialog
        open={open}
        handleClose={() => {
          resetState();
          close(false);
        }}
        loading={loading}
        fullScreen={fullScreen}
        handleSubmit={handleSubmit}
        buttonTxt="Save"
        title="AttachFile"
        // width="400px"
        fullWidth={true}
        disabled={file[0]?.file === null || loading}
      >
        <Form
          file={file}
          name={name}
          handleNameChange={handleNameChange}
          handleFileChange={handleFileChange}
          isMobile={isMobile}
          className={isMobile ? "mobile-attach-file-dialog-form" : ""}
        />
      </FormDialog>
    </React.Fragment>
  );
}
